import { useQuery } from '@tanstack/react-query';
import { Dispatch, SetStateAction, useState } from 'react';
import { useAuthorizedAxios } from '../../../core/hooks';
import { defaultPaginationSettings, PaginationViewModel } from '../../../core/model';
import { isValidCustomerId } from '../../../customers';
import { getItsmNetworkServiceIncidents } from '../../api';
import { ItsmHttpQueryConfig } from '../../config';
import { ItsmNetworkServiceIncidentApiModel } from '../../model';

export interface ItsmNetworkServiceIncidentsApiGetHookResult {
  data: ItsmNetworkServiceIncidentApiModel[];
  pagination: PaginationViewModel;
  setPagination: Dispatch<SetStateAction<PaginationViewModel>>;
  total: number;
  isFetching: boolean;
  isFetched: boolean;
}

export const useItsmNetworkServiceIncidents = (customerId: number | null): ItsmNetworkServiceIncidentsApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const [pagination, setPagination] = useState<PaginationViewModel>(defaultPaginationSettings());
  const { data, isFetching, isFetched } =  useQuery({
    queryKey: [ItsmHttpQueryConfig['GetItsmNetworkServiceIncidents'].key, customerId, pagination],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        return await getItsmNetworkServiceIncidents(axios, { customerId, pagination });
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false,
  });
  const response = data || { total: 0, data: [] };
  return {
    isFetched,
    isFetching,
    pagination,
    setPagination,
    data: response?.data,
    total: response?.total,
  }
};